import React, { useState, useEffect, useRef, Children } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import ImageChecker from '../../Generic/ImageChecker';


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, InputNumber, 
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem, searchData} from '../../../Redux/actions/crudActions'
import {errorParser,numberWithCommas} from '../../../utils/helpers'
import {getInBranchItems,setMonthlyInventory,updateMonthlyInventory} from '../../../Redux/actions/monthlyInventoryActions'

import {getProduct} from '../../../Redux/actions/productActions'
import {setProductInventory,setProductInventoryWithLocation} from '../../../Redux/actions/inventoryActions'
import {getWeightedExchangeRate,calculateWeightedExchangeRate} from '../../../Redux/actions/exchangerateActions'
import {getProductInventoryLog} from '../../../Redux/actions/inventoryActions'

import ProductBranchLogTable from '../ProductBranchLogTable'


const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;


const Index = ({branchID,productID, product,displayType}) => { 
    
    const dispatch = useDispatch()    
    const { branchitems, user } = useSelector(
      state => ({
        branchitems: state.monthlyInventory.branchitems,
        user: state.auth.user,
      }),
      shallowEqual
    )


  
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])

    const [lastWeekTotal, setLastWeekTotal] = useState(0)

    const [twoMonthAve, setTwoMonthAve] = useState(0)


    const getTableData =  async() =>{
 
      setLoading(true)

      var newdata = await dispatch(getProductInventoryLog(branchID,productID))
      setData(newdata)
      setLoading(false)
    }


    useEffect(() => {
  
        if(branchID && productID){

          getTableData()
        }
    },[branchID,productID]);

    useEffect(() => {
      if(data){
        calculatequickstats()
      }
  },[data]);

    const calculatequickstats = () =>{
      // console.log('branchitems',branchitems)
      // let currentbranch = branchitems.filter(obj => obj.id == branchID);
      // console.log('currentbranch',currentbranch)
      console.log(data)
      
      var data_to_use = []
      data.map((element, index) => {
        
        var change = 0
        if(data[index+1]){
          if((data[index]?.quantity && data[index+1]?.quantity ) || (data[index]?.quantity == 0 || data[index+1]?.quantity == 0)){
            
            var now = 0
            var then = 0

            if(data[index].quantity){
              now = data[index].quantity
            }
            if( data[index+1].quantity){
              then = data[index+1].quantity
            }
        
            change = parseFloat(now - then)     
        
        }
        }
    
        
        var new_element = {
          ...element,
          change: change
        }
        console.log(new_element)
        if(element.reason == 'used' || element.reason == 'packed' ){
          data_to_use.push( new_element)

        }

  
      });
  
      console.log('data_to_use',data_to_use)
      let oneWeekAgo = moment().subtract(1, 'weeks');
      let lastWeek = data_to_use.filter(function(obj) {
        let objDate = moment(obj.created_at);
        return objDate.isSameOrAfter(oneWeekAgo);
      });
      // console.log(lastWeek)
      let totalQuantity = lastWeek.reduce((acc, cur) => acc + Math.abs(cur.change), 0);
      console.log(totalQuantity);
      setLastWeekTotal(totalQuantity)

      let twoMonthsAgo = moment().subtract(2, 'months');
      let lastTwoMonths = data_to_use.filter(function(obj) {
        let objDate = moment(obj.created_at);
        return objDate.isSameOrAfter(twoMonthsAgo);
      });
      let weeksInTwoMonths = moment().diff(twoMonthsAgo, 'weeks');
      let totalQuantity2 = lastTwoMonths.reduce((acc, cur) => acc +  Math.abs(cur.change), 0);
      let weeklyAvg = totalQuantity2 / weeksInTwoMonths;
      console.log(weeklyAvg);
      setTwoMonthAve(weeklyAvg)
    }

    return(       
      <>
       {displayType ==1 ?
      <div className={`product-quickstats`} >
        <Statistic title="Last Week's Total" value={numberWithCommas(parseFloat(lastWeekTotal).toFixed(2))} suffix={product.unit} />
        <Statistic title="Weekly Average (2 months)" value={numberWithCommas(parseFloat(twoMonthAve).toFixed(2))} suffix={product.unit}  />
          
      </div>
      : null}
       {displayType ==2 ?
      
           <Descriptions size={'small'} column={1} layout={'vertical'} bordered>
            <Descriptions.Item label="Last Week">{numberWithCommas(parseFloat(lastWeekTotal).toFixed(2))}</Descriptions.Item>
            <Descriptions.Item label="2 Month Ave.">{numberWithCommas(parseFloat(twoMonthAve).toFixed(2))}</Descriptions.Item>
          </Descriptions>
    
      : null}
     
      </>
    )
}
  
export default Index
  